import { createContext } from 'react'
import { Airport } from './airports/Airport'

const AirportsContext = createContext<Airport[] | undefined>(undefined)

export default AirportsContext
